import {Svg} from "@/shared/ui/Svg";
import {useShareArticle} from "../model/useShareArticle";
import styles from "./ShareButton.module.scss";

export const ShareButton = ({text, isMobile}) => {
    const {share, copied} = useShareArticle(text, isMobile);

    if (isMobile) {
        return (<Svg id={`shareOutlinedIcon`} className={styles.share} onClick={share} />);
    }

    return (
        copied
            ? <Svg id={`doneAllOutlinedIcon`} className={styles.copiedIcon} onClick={share} />
            : <Svg id={`copyIcon`} className={styles.copyIcon} onClick={share} />
    );
};
